import { appLanguage } from '@orientaction/reducers';
import { useSelector } from 'react-redux';
import Page00 from '../../../../Book/EbookEtape_5/Page/00';
import Page01 from '../../../../Book/EbookEtape_5/Page/01';
import Page02 from '../../../../Book/EbookEtape_5/Page/02';
import Page03 from '../../../../Book/EbookEtape_5/Page/03';
import Page04 from '../../../../Book/EbookEtape_5/Page/04';
import Page05 from '../../../../Book/EbookEtape_5/Page/05';
import Page06 from '../../../../Book/EbookEtape_5/Page/06';
import Page07 from '../../../../Book/EbookEtape_5/Page/07';
import Page08 from '../../../../Book/EbookEtape_5/Page/08';
import Page09 from '../../../../Book/EbookEtape_5/Page/09';
import Page10 from '../../../../Book/EbookEtape_5/Page/10';
import Page11 from '../../../../Book/EbookEtape_5/Page/11';
import Page12 from '../../../../Book/EbookEtape_5/Page/12';
import Page13 from '../../../../Book/EbookEtape_5/Page/13';
import Page14 from '../../../../Book/EbookEtape_5/Page/14';
import Page15 from '../../../../Book/EbookEtape_5/Page/15';
import Page16 from '../../../../Book/EbookEtape_5/Page/16';
import Page17 from '../../../../Book/EbookEtape_5/Page/17';
import Page18 from '../../../../Book/EbookEtape_5/Page/18';
import Page20 from '../../../../Book/EbookEtape_5/Page/19';
import Page21 from '../../../../Book/EbookEtape_5/Page/20';
import Page22 from '../../../../Book/EbookEtape_5/Page/21';
import Page23 from '../../../../Book/EbookEtape_5/Page/22';
import Page24 from '../../../../Book/EbookEtape_5/Page/23';
import Page25 from '../../../../Book/EbookEtape_5/Page/24';
import Page26 from '../../../../Book/EbookEtape_5/Page/25';
import Page27 from '../../../../Book/EbookEtape_5/Page/26';
import Page28 from '../../../../Book/EbookEtape_5/Page/27';
import Page29 from '../../../../Book/EbookEtape_5/Page/28';
import Page30 from '../../../../Book/EbookEtape_5/Page/29';
import Page31 from '../../../../Book/EbookEtape_5/Page/30';
import Page32 from '../../../../Book/EbookEtape_5/Page/31';
import Page33 from '../../../../Book/EbookEtape_5/Page/32';
import Page34 from '../../../../Book/EbookEtape_5/Page/33';
import Page35 from '../../../../Book/EbookEtape_5/Page/34';
import Page35a from '../../../../Book/EbookEtape_5/Page/35a';
import Page36 from '../../../../Book/EbookEtape_5/Page/35';

type StepContentProps = {
  readOnly: boolean;
};

const Step5Content = ({ readOnly }: StepContentProps) => {
  const lang: string = useSelector(appLanguage);

  return (
    <>
      <Page00 />
      <Page01 />
      <Page02 />
      <Page03 />
      <Page04 readOnly={readOnly} />
      <Page05 />
      <Page06 />
      <Page07 />
      <Page08 />
      <Page09 />
      <Page10 />
      <Page11 />
      <Page12 readOnly={readOnly} />
      <Page13 readOnly={readOnly} />
      <Page14 readOnly={readOnly} />
      <Page15 readOnly={readOnly} />
      <Page16 readOnly={readOnly} />
      <Page17 readOnly={readOnly} />
      <Page18 />
      <Page20 />
      <Page21 />
      <Page22 readOnly={readOnly} />
      <Page23 readOnly={readOnly} />
      <Page24 readOnly={readOnly} />
      <Page25 readOnly={readOnly} />
      <Page26 />
      <Page27 />
      <Page28 />
      <Page29 />
      <Page30 />
      <Page31 />
      <Page32 />
      <Page33 readOnly={readOnly} />
      <Page34 />
      <Page35 />
      <Page36 />
      {lang !== 'GB' && <Page35a />}
    </>
  );
};

export default Step5Content;
